import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

const StudyGuide = () => {
  const subject = localStorage.getItem('currentSubject');
  const studyGuide = JSON.parse(localStorage.getItem('studyGuide') || '{}');
  const navigate = useNavigate();

  if (!studyGuide.topics) {
    return (
      <div className="study-guide-container">
        <div className="empty-state">
          <h2>No study guide available</h2>
          <p>Generate a study guide by selecting a subject first</p>
          <Link to="/" className="btn btn-primary">Go Home</Link>
        </div>
      </div>
    );
  }

  const startLearningPath = () => {
    navigate('/learning-path', { state: { topic: subject } });
  };

  return (
    <div className="study-guide-container">
      <div className="study-guide-header">
        <h1>{subject}</h1>
        <p className="subtitle">Your comprehensive study guide</p>
      </div>
      
      <div className="overview-section">
        <h2>📖 Overview</h2>
        <p>{studyGuide.overview}</p>
      </div>

      <div className="learning-path-cta">
        <div className="cta-content">
          <h3>🎯 Want a structured learning path?</h3>
          <p>Get an AI-generated learning journey with interactive lessons, quizzes, and progress tracking!</p>
          <button className="btn btn-primary btn-large" onClick={startLearningPath}>
            Start Learning Path →
          </button>
        </div>
      </div>

      <div className="topics-section">
        <h2>📚 Key Topics to Master</h2>
        <div className="topics-grid">
          {studyGuide.topics.map((topic, index) => (
            <div key={index} className="topic-card">
              <div className="topic-header">
                <span className="topic-icon">📘</span>
                <h3>{topic.name}</h3>
              </div>
              <p className="topic-description">{topic.description}</p>
              
              <div className="concepts-list">
                <h4>Key Concepts:</h4>
                <ul>
                  {topic.concepts.map((concept, conceptIndex) => (
                    <li key={conceptIndex}>
                      <span className="concept-bullet">•</span>
                      {concept}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="study-actions">
        <h2>Practice & Test Your Knowledge</h2>
        <div className="action-grid">
          <Link to="/quiz" className="action-card">
            <div className="action-icon">📝</div>
            <h3>Take a Quiz</h3>
            <p>Test your knowledge with AI-generated questions</p>
          </Link>
          <Link to="/flashcards" className="action-card">
            <div className="action-icon">🎴</div>
            <h3>Flashcards</h3>
            <p>Practice with interactive flashcards</p>
          </Link>
          <div className="action-card" onClick={startLearningPath}>
            <div className="action-icon">🗺️</div>
            <h3>Learning Path</h3>
            <p>Follow a structured, gamified journey</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudyGuide;